import { createFileRoute } from '@tanstack/react-router';
import { MasterObligationEdit } from './MasterObligationEdit';

export const Route = createFileRoute('/admin-console/platform-content/obligations/library/details/$id/manage')({
    component: () => <MasterObligationEdit />,
});
